module.exports = __webpack_public_path__ + "img/footer-smok1.149bc8ef.png";